export class DegreeParticipation {
    id: number;
    name: string;
    code: string;
}